import React from 'react';

import EmptyStateCard from 'benchling-apps/EmptyStateCard';

export default function NoSessionsCard(): JSX.Element {
  return (
    <EmptyStateCard
      title="No sessions recorded"
      message={
        <>
          Sessions appear when
          <br />
          apps have this feature implemented
          <br />
          and have sent data to Benchling
        </>
      }
    />
  );
}
